import { COLORS } from '@btime/constants'
import { prop } from 'ramda'
import React from 'react'

import { BGImage } from './Image'
import { Text } from './Text'
import FlexGrid from '../structure/FlexGrid'
import Separator from '../helpers/Separator'

const Signature = ({ item }) => {
  const name = prop('name', item)
  const doc = prop('document', item)

  return (
    <div>
      <BGImage
        padding="1.5rem"
        height="10rem"
        width="42rem"
        alt="Signature"
        dashedFrame
        frameColor={COLORS.light3}
        src={item.src}
      />

      {!!doc || (!!name && <Separator weight={2} />)}

      <FlexGrid gutter={2} justify="flex-start">
        {!!name && (
          <Text>
            <b>Nome:</b> {name}
          </Text>
        )}
        {!!doc && (
          <Text>
            <b>Documento:</b> {doc}
          </Text>
        )}
      </FlexGrid>
    </div>
  )
}

export default Signature
